import React, { useEffect, useMemo, type FC } from 'react'
import { useIntl } from 'react-intl'
import { useAtom } from 'jotai'
import {
  FormElement,
  Select,
  SELECT_VARIANT_WITH_CHECKBOX,
  GridCell,
} from 'mailup-web-components'
import { filterFormImmerAtom } from '../../state/state'
import { type ConditionProps } from '../../types'
import { type SelectOption } from '../../../../helpers/types'
import { allGroupsAtom } from '../../state/specState'
import { useAtomCallback } from 'jotai/utils'
import { getAllGroupsCallback } from '../../callbacks/specsCallbacks'
import { type UiGroupSpec } from '../../filterConditionTypes'

const GroupSpecCondition: FC<ConditionProps> = ({ blockIndex, condIndex }) => {
  const intl = useIntl()
  const [filter, setFilter] = useAtom(filterFormImmerAtom)
  const condition = filter.Blocks[blockIndex].Conditions[condIndex]
  const spec = condition.Spec as UiGroupSpec

  const isMultiList = filter.IdList === 0
  const [allGroups] = useAtom(allGroupsAtom)
  const getAllGroups = useAtomCallback(getAllGroupsCallback)
  const allGroupsMapped: SelectOption[] = useMemo(
    () => [
      {
        label: intl.formatMessage({ id: 'Load.Filters.NoGroupOption' }),
        value: 0,
      },
      ...allGroups.map<SelectOption>((g) => {
        return {
          label: `${g.Id} - ${g.Name}`,
          value: g.Id,
        }
      }),
    ],
    [allGroups, intl],
  )

  useEffect(() => {
    void getAllGroups()
  }, [getAllGroups])

  const handleChange = (values: number[]): void => {
    setFilter((draft) => {
      const draftSpec = draft.Blocks[blockIndex].Conditions[condIndex]
        .Spec as UiGroupSpec
      draftSpec.Values = values
    })
  }

  return (
    <GridCell span={9}>
      <FormElement
        hint={intl.formatMessage({ id: 'Load.Filters.SelectGroupsORTips' })}
        feedbackVariant={isMultiList ? 'danger' : undefined}
        feedback={
          isMultiList
            ? intl.formatMessage({
                id: 'Load.Filters.InputErrorFilterMultilist',
              })
            : undefined
        }
      >
        <Select
          placeholder={
            isMultiList
              ? intl.formatMessage({
                  id: 'Load.Filters.GroupDisabledPlaceholder',
                })
              : intl.formatMessage({
                  id: 'Load.Filters.SelectGroupsORPlaceholder',
                })
          }
          options={allGroupsMapped}
          multiple
          variant={SELECT_VARIANT_WITH_CHECKBOX}
          value={spec.Values}
          onChange={handleChange}
          error={isMultiList}
          disabled={isMultiList}
          data-mu-test='input-select-groups'
        />
      </FormElement>
    </GridCell>
  )
}

export default GroupSpecCondition
